import { x } from '@xstyled/styled-components';
import React, { FC, useEffect, useMemo } from 'react';
import { RightMatchItem } from '../QuizMatchStore';
import { CorrectBadge } from './CorrectBadge';
import { IncorrectBadge } from './IncorrectBadge';
import { LeftButton } from './LeftButton';
import { RightBorder } from './RightBorder';
import { RightShape, DropBox } from './RightShape';
import { useColor } from './useColor';
import audioEffectRightAnswer from '~/assets/mp3/right_answer.mp3';
import audioEffectWrongAnswer from '~/assets/mp3/wrong_answer.mp3';
import { useAudioEffect } from '~/ui/audio-effect/useAudioEffect';

export const RightButton: FC<
  RightMatchItem & {
    onClick?: () => void;
    onClickLeftButton?: (pairId: string) => void;
  }
> = ({ label, pairId, leftItem, onClick, onClickLeftButton }) => {
  const correct = useMemo(() => {
    if (leftItem) return pairId === leftItem.pairId;
  }, [leftItem]);
  const color = useColor(correct);
  const [playAudioEffectRightAnswer] = useAudioEffect(audioEffectRightAnswer);
  const [playAudioEffectWrongAnswer] = useAudioEffect(audioEffectWrongAnswer);

  useEffect(() => {
    if (correct !== undefined) {
      correct ? playAudioEffectRightAnswer() : playAudioEffectWrongAnswer();
    }
  }, [correct]);

  return (
    <RightBorder
      highlightColor={color}
      className="RightBorder"
      onClick={onClick}
    >
      {correct === true ? (
        <CorrectBadge position="absolute" top="0" right="0" />
      ) : (
        ''
      )}
      {correct === false ? (
        <IncorrectBadge position="absolute" top="0" right="0" />
      ) : (
        ''
      )}{' '}
      <DropBox className="DropBoxRightPart">
        <RightShape className="RightShape">
          {leftItem && (
            <x.div position="absolute" right="100%">
              <LeftButton
                {...leftItem}
                correct={leftItem.pairId === pairId}
                onClick={() => onClickLeftButton!(leftItem.pairId)}
              />
            </x.div>
          )}
          {label}
        </RightShape>
      </DropBox>
    </RightBorder>
  );
};
